export const trainDetailsI18n = [
    {
        key: "details.price.from",
        de: "ab {0}",
        en: "from {0}",
        it: "da {0}",
        fr: "à partir de {0}",
        nl: "vanaf {0}",
    },
    {
        key: "details.facilities",
        de: "Fahrzeugtransport ({0})",
        en: "Vehicle transport ({0})",
        it: "Trasporto veicoli ({0})",
        fr: "Transport de véhicules ({0})",
        nl: "Voertuigtransport ({0})",
    },
    {
        key: "details.facilities.car",
        de: "Auto",
        en: "car",
        it: "auto",
        fr: "voiture",
        nl: "auto",
    },
    {
        key: "details.facilities.motorcycle",
        de: "Motorrad",
        en: "motorcycle",
        it: "moto",
        fr: "moto",
        nl: "motor",
    },
    {
        key: "details.facilities.bike",
        de: "Fahrradmitnahme möglich",
        en: "Bicycle transport is possible",
        it: "Possibilità di trasporto biciclette",
        fr: "Possibilité d'emmener le vélo",
        nl: "Fietstransport mogelijk",
    },
    {
        key: "details.facilities.wheelchair",
        de: "Rollstuhlabteil vorhanden",
        en: "Wheelchair compartment available",
        it: "Scomparto sedia a rotelle disponibile",
        nl: "Rolstoelafdeling aanwezig",
        fr: "Section chaise roulante",
    },
    {
        key: "details.fineprint.partner",
        de: "Bei EuroNight-Zügen können Serviceumfang und Wagenmaterial vom dargestellten ÖBB Nightjet-Angebot abweichen.",
        en: "On EuroNight trains, the scope of services and rolling stock may differ from the ÖBB Nightjet offer shown.",
        it: "Sui treni EuroNight, l'ambito dei servizi e del materiale rotabile può differire dall'offerta ÖBB Nightjet mostrata.",
        fr: "Sur les trains EuroNight, l'étendue des services et du matériel roulant peut différer de l'offre ÖBB Nightjet présentée.",
        nl: "Op EuroNight-treinen kan de omvang van de diensten en het rollend materieel afwijken van het getoonde ÖBB Nightjet-aanbod.",
    },
    {
        key: "details.fineprint.construction",
        de: "Durch Baustellen kann es zu Abweichungen vom regulären Fahrplan kommen - bitte beachten Sie daher die aktuellen Fahrzeiten und Halte unter {0}.",
        en: "Due to construction sites, deviations from the regular timetable may occur - please pay attention to the current timetables and stops at {0}.",
        it: "A causa di lavori, si possono verificare delle deviazioni dal percorso regolare - si prega di prestare attenzione agli orari e alle fermate attuali su {0}.",
        fr: "Des chantiers peuvent entraîner des modifications de l'horaire régulier - veuillez regarder les horaires actuels et haltes actuelles sur {0}.",
        nl: "Vanwege bouwplaatsen kunnen afwijkingen van de dienstregeling ontstaan - let daarom op de huidige vertrektijden en stations op {0}.",
    },
    {
        key: 'timetable.loading',
        de: 'Zuglauf wird geladen ...',
        en: 'Train route is loading ...',
        it: 'Scaricando il percorso del treno ...',
        fr: "L'itinéraire du train est en cours de chargement ...",
        nl: 'Treinroute wordt geladen ...',
    },
    {
        key: 'timetable.not-found',
        de: 'Für den ausgewählten Tag konnte keine direkte Nachtzugverbindung gefunden werden.',
        en: 'No direct night train connection could be found for the selected day.',
        it: 'Non è stato trovato alcun collegamento ferroviario notturno diretto per il giorno selezionato.',
        fr: 'Aucune liaison ferroviaire de nuit directe n\'a pu être trouvée pour le jour sélectionné.',
        nl: 'Voor de geselecteerde dag kon geen directe nachttreinverbinding worden gevonden.',
    },
    {
        key: 'timetable.unavailable',
        de: 'Bitte versuchen Sie es später erneut.',
        en: 'Please try again later.',
        it: 'Per favore riprova più tardi.',
        fr: 'Veuillez réessayer plus tard.',
        nl: 'Probeer het later nog eens.',
    },
];
//# sourceMappingURL=train-details-i18n.js.map
